// extracted by mini-css-extract-plugin
export default {"noticeBannerContainer":"AccountNoticeBanner_noticeBannerContainer__hRFmT"};